mainApp.directive('eventStatistics', function() {
    return {
        templateUrl: '/public/directives/eventStatistics.html',
        scope: {
            type: "=",
            finishedLoading: "=?",
            entityFilterOptions: "=?",
            monitorItems: "=?",
            options: "=?",
            tabFilter: "=",
            events: "@"
        },
        controller: ["$scope", "$interval", "$timeout", "$rootScope", "$filter", "$state", "$element", "GeneralUtilsService", 'DateRangeService', function ($scope, $interval, $timeout, $rootScope, $filter, $state, $element, GeneralUtilsService, DateRangeService) {

            var icons = {
                key:"type",
                values:{
                    "SITE":"site",
                    "ACCESSLOGIN":"user",
                    "GROUP":"group",
                    "App":"app",
                    "AppCategory":"category",
                    "Service":"service",
                    "URLFilter":"search",
                    "SUBNET":"cloud-download",
                    "HOSTSUBNET": "host",
                    "INTERFACEIPRANGE": "iprange"
                }
            };

//            $scope.avFilter = {
//                field: "type",
//                selectedOption: "ANTIVIRUS"
//            };
            $scope.dateRange = DateRangeService.getNewRange();
            DateRangeService.initDateRange($scope.dateRange, true);

            $scope.$watch('dateRange.from', function (newValue, oldValue) {
                if (!_.isEqual(newValue, oldValue)) {
                    setAggConfig();
                    $scope.refreshtable = new Date().getTime();
                }
            }, true);
            $scope.$watch('dateRange.to', function (newValue, oldValue) {
                if (!_.isEqual(newValue, oldValue)) {
                    setAggConfig();
                    $scope.refreshtable = new Date().getTime();
                }
            }, true);

            $scope.loaders = {
                threats: true,
                domains: true,
                hosts: true
            };
            $scope.options={};
            $scope.dateField = "startTime";
            $scope.facets = [{"id": "site_id", label: "Client"},{"id": "admin_id", label: "Client"},{"id": "action"},{"id": "documentGroupId", "ignoreFilter": true, "hide": true},
                {"id": "tunnel_host_name", "label": "Client"}, {"id": "virus_name", "label": "Malware"}];

            $scope.facets1 = [{"id": "virus_name", "label": "virus_name", innerAggregationField:"client_ip"}];
            $scope.facets2 = [{"id": "host_name", "label": "tunnel_host_name"}];
            $scope.facets3 = [{"id": "site_id", "label": "client_ip", innerAggregationField:"client_ip"}];


            $scope.index = "events";
//            $scope.facets = [{"id": "site_id", label: "app_rule_id", "ignoreFilter": true, "hide": true}, {"id": "access_rule_id", "ignoreFilter": true, "hide": true},{"id": "url_category", "ignoreFilter": true, "hide": true}];
            $scope.aggregationConfig = {};

            $scope.catoentitieshoststable =  {
                showLoader: false,
                defer: false,
                noSearch: true,
                titleSearch: false,
                expand: false,
                hideFacets: true,
                hideHead: false,
                inheritSetting: true,
                processData : true,
                legend: false,
                showPopUp: true,
                useFacetsAsItems: false,
                dynamicTableConfig: function (item){
                    var fields = {
                        "fields": [
                            {"label":"Source Host","noSort":false, "path":"tunnel_remote_ip","width": 1,"template":"<span>{{item.tunnel_host_name || item.client_ip}}</span>"},
                            {"label":"Source Country", "noSort":true,"width": 1,"template":"<span><span class='flag-icon flag-icon-{{item.tunnel_remote_ip_country_code | lowercase}}'/> {{item.tunnel_remote_ip_country}}</span>"},
                            {"label":"Destination IP","noSort":false, "path":"server_ip","width": 1,"template":"<span>{{item.server_ip}}</span>"},
                            {"label":"Destination Country","noSort":true, "width": 1,"template":"<span><span class='flag-icon flag-icon-{{item.server_ip_country_code  | lowercase}}'/> {{item.server_ip_country}}</span>"},
                            {"label":"Malware Name","noSort":false, "path":"virus_name","width": 1,"template":"<span>{{item.virus_name}}</span>"},
                            {"label":"URL","noSort":true, "width": 1,"template":"<div class='ellipsis' style='width:150px'><span>{{item.url}}</span></div>"},
                            {"label":"SHA-256", "noSort":true, "width": 1,"template":"<div class='ellipsis' style='width:70px'><span>{{item.file_hash}}</span></div>"}
                        ]
                    };
                    if ($scope.$root.userAwareness) {
                        fields.fields.unshift({"label":"Source User","noSort":false, "path":"tunnel_host_logon_names","width": 1,"template":"<span>{{item.tunnel_host_logon_names || 'N/A'}}</span>"});
                    }
                    return fields;
                },
                dynamicAggregationConfig: function(item, aggregator){
                    var aggregationConfig = {
                        "rawData": true,
                        "filter": {
                            "fields": {
                                "type" : {
                                    "label": "type",
                                    "includeMissing": false,
                                    "values": ["ANTIVIRUS"]
                                },
                                "site" : {
                                    "label": "site_id",
                                    "includeMissing": false,
                                    "values": [item.value]
                                }
                            }
                        }
                    };

                    for(var bucket in aggregator.buckets){
                        var currentBucket = aggregator.buckets[bucket];

                        if(currentBucket.values.length > 0){
                            aggregator.facetFields.forEach(function(facet){
                                if((facet.label || facet.id) === bucket){
                                    var filterValues = [];
                                    var currentFacetData = _.findWhere(aggregator.facets, {id: facet.id});

                                    currentBucket.values.forEach(function(value){
                                        for(var i=0;currentFacetData.items[i];i++){
                                            if(currentFacetData.items[i].value === value.value || currentFacetData.items[i].id === value.id){
                                                filterValues.push(value.id);
                                                break;
                                            }
                                        }
                                    });

                                    aggregationConfig.filter.fields[currentFacetData.id || currentFacetData.label] = {
                                        label: currentFacetData.id || currentFacetData.label,
                                        includeMissing: false,
                                        values: filterValues
                                    };
                                }
                            });
                        }

                    }
                    return aggregationConfig;
                }
            };

            $scope.$watch('facets', function(newValue){
                console.log(newValue);
            });
            $scope.$watch('dateField', function(newValue){
                console.log(newValue);
            });

            $scope.$watch('tableConfig.openFilters', function(newValue){
                $timeout(function(){
//                    setChartMargin();
                }, 1, false);
            });
            /*
             Init
             */
            var DEFAULT_LINE_COLOR = "#FF6600";

            $scope.posupdate = 0;

            $scope.addFilter = {};

            (function filter() {
                var monitoringFilter = $scope.$parent.tabFilter;
                if(!$scope.addFilter){
                    $scope.addFilter = {};
                }

                if(monitoringFilter && (monitoringFilter.pid || monitoringFilter.pid == 0)){
                    $scope.currentName = monitoringFilter.name;
                    $scope.currentType = monitoringFilter.type;
                    $scope.pid = monitoringFilter.pid;
                    $scope.addFilter['site_id'] = {
                        label:"site_id",
                        values:[$scope.pid]
                    }
                }

                $scope.addFilter['type'] = {
                    "label": "type",
                    "values": ["ANTIVIRUS"]
                }
            })();

            $scope.currentcounter = {name: 'EventsCounts', unit: 'Events', label: 'Events', order: 9};

            $scope.tableConfig = {
                processData: function(data,queryResults,expandable){
                    for(var i=0;data[i];i++){
                        if(data[i].startTime){
                            if(data[i].endTime){
                                data[i].duration = moment.duration(data[i].endTime - data[i].startTime).humanize();
                            }
                            else {
                                data[i].duration = null;
                            }
                            if (expandable){
                                data[i].startTimeNumber = data[i].startTime;
                                data[i].startTime = moment(data[i].startTime).calendar();
                            }
                            else{
                                data[i].startTimeNumber = data[i].startTime;
                                data[i].startTime = moment(data[i].startTime).format('lll');
                            }
                        }
                        else{
                            data[i].startTime = null;
                        }
                    }
                    return(data);
                },
                fields : [
                    {"label":"Time","path":"startTime","width": 1,"template":"<span><time>{{item.startTime}}</time></span>"},
                    {"label":"Duration", "noSort":true, "path":"duration","width": 1,"template":"<span><time>{{item.duration}}</time></span>"},
                    {"label":"FRQ","path":"count","width": 1,"template": "<span>{{item.count}}</span>"},
                    {"label":"Type","noSort":true, "path":"type","width": 2,"template": '<span><span class="" data-id="ANTIVIRUS">Anti Malware</span></span>'},
                    {"label":"Source","noSort":true, "path":"site_id","width": 2,"template": '<span >{{item.site || item.accessLogin || item.admin}}</span>'},
                    {"label":"Destination", "noSort":true, "width": 2,"template": '<span >{{item.rt_site || item.appid || item.url_category_name || "N/A"}}</span>'},
                    {"label":"Action","noSort":true, "path":"action","width": 2,"template": '<span class="action-field {{item.action | lowercase}}">{{item.action | capitalize}}</span>'},
                    {"label":"Details", "noSort":true, "width": 2,"template": '<span >{{item.type === "ACCESS_RULE" ? item.appid : ""}}</span>'}
                ],
                type: "events",
                index: "events",
                showLoader: !$scope.waitforfilter,
                sortField: "startTime",
                sortDir: "DESC",
                facets: $scope.facets,
                fromDate: $scope.dateRange.from.getTime(),
                toDate: $scope.dateRange.to.getTime(),
                dateField: "startTime",
                watchDate: false,
                hideCheckboxes: true,
                addFilter: $scope.addFilter,
                expand: true,
                noSearch: true,
                fixedLayout: true,
                icons: icons,
                afterUpdate: function(){
                    setChartMargin();
                },
                showPopUp: function(type,item,rowId){
                   /* var url = "";
                    var id;
                    var accountId = $state.params.accountId;

                    store.fetch({
                        data: queryConfig,
                        dataObj: 'dataConfig',
                        method: 'POST',
                        path: url,
                        success: function(data) {
                            $scope.chartdata = data;
                            if (data.total === 0){
                                $scope.scopeSelection = {"id":id, type: type};
                                $scope.$root.$emit("$openPopup", "notAvailbalePopup", "eventRow_"+item.documentGroupId+"_"+rowId, {topMod: -60, leftMod: $("#eventRow_"+item.documentGroupId+"_"+rowId).outerWidth() + ($rootScope.menuClosed? -71 : -230)});
                            }
                            else{
                                $scope.scopeSelection = {"item":data.items[0], "id":id, type: type};

                                $scope.$root.$emit("$openPopup", type+"Popup", "eventRow_"+item.documentGroupId+"_"+rowId, {topMod: -60, leftMod: $("#eventRow_"+item.documentGroupId+"_"+rowId).outerWidth() + ($rootScope.menuClosed? -71 : -230)});
                            }
                        }
                    });*/
                },
                innerTable: {
                    showLoader: false,
                    defer: false,
                    titleSearch: false,
                    showTitleSearch:false,
                    noSearch: true,
                    expand: false,
                    hideFacets: true,
                    hideHead: false,
                    inheritSetting: true,
                    processData : true,
                    showPopUp: true,
                    dynamicTableConfig: function (item){
                        var fields = {
                            "fields": [
                                {"label":"Time","path":"startTime","width": 1,"template":"<span><time>{{item.startTime}}</time></span>"},
                                {"label":"Frequency","noSort":false, "path":"count","width": 1,"template": "<span><span>{{item.count}}</span></span>"},
                                {"label":"Source Host","noSort":false, "path":"tunnel_remote_ip","width": 1,"template":"<span>{{item.tunnel_host_name || item.tunnel_host_netbios_name || item.tunnel_host_reverse_dns || item.client_ip}}</span>"},
                                {"label":"Source Country", "noSort":true,"width": 1,"template":"<span><span class='flag-icon flag-icon-{{item.tunnel_remote_ip_country_code | lowercase}}'/> {{item.tunnel_remote_ip_country}}</span>"},
                                {"label":"Destination IP","noSort":false, "path":"server_ip","width": 1,"template":"<span>{{item.server_ip}}</span>"},
                                {"label":"Destination Country","noSort":true, "width": 1,"template":"<span><span class='flag-icon flag-icon-{{item.server_ip_country_code  | lowercase}}'/> {{item.server_ip_country}}</span>"},
                                {"label":"Destination Port","noSort":false, "path":"server_port","width": 1,"template":"<span>{{item.server_port}}</span>"},
                                {"label":"Service", "noSort":false, "width": 1,"template": '<span><span class="">{{item.appid || item.tl_name}}</span></span>'},
                                {"label":"App Categories", "noSort":true, "width": 1,"template":"<span>{{item.app_categories || item.url_category_name}}</span>"},
                                {"label":"HTTP host","noSort":false, "path":"host_name","width": 1,"template":"<span>{{item.host_name}}</span>"},
                                {"label":"DNS","noSort":false, "path":"server_port","width": 1,"template":"<span>{{item.server_hname}}</span>"},
                                {"label":"URL","noSort":true, "width": 1,"template":"<div class='ellipsis' style='width:150px'><span>{{item.url}}</span></div>"},
                                {"label":"SHA-256", "noSort":true, "width": 1,"template":"<div class='ellipsis' style='width:70px'><span>{{item.file_hash}}</span></div>"},
                                //                            fields.fields.push({"label":"SHA-1", "noSort":false, "width": 1,"template":"<div class='ellipsis' style='width:70px'><span style='text-overflow:ellipsis; width:100%; overflow:hidden; vertical-align: bottom;' id='eventRow_{{item.documentGroupId}}_{{$parent.$index}}' class='action-link' ng-click='tableConfig.showPopUp("+"\"avConfigException\""+",item,$parent.$index)'>{{item.file_hash}}</span></div>"});
                                {"label":"Info", "noSort":true, "width": 1,"template":"<span><a href='https://www.virustotal.com/en/search/?query={{item.file_hash}}' target='_blank'>VirusTotal</span>"}
                            ]
                        };
                        if ($scope.$root.userAwareness) {
                            fields.fields.splice(2,0,{"label":"User","noSort":false, "path":"tunnel_host_logon_names","width": 1,"template":"<span>{{item.tunnel_host_logon_names || 'N/A'}}</span>"});
                        }

                        return fields;
                    },
                    dynamicAggregationConfig: function(item, aggregator){
                        var aggregationConfig = {
                            "rawData": true,
                            "filter": {
                                "fields": {
                                    "documentGroupId" : {
                                        "label": "documentGroupId",
                                        "includeMissing": false,
                                        "values": [item.documentGroupId]
                                    }
                                }
                            }
                        };

                        for(let bucket in aggregator.buckets){
                            let currentBucket = aggregator.buckets[bucket];

                            if(currentBucket.values.length > 0){
                                aggregator.facetFields.forEach(function(facet){
                                    if((facet.label || facet.id) === bucket){
                                        var filterValues = [];
                                        var currentFacetData = _.findWhere(aggregator.facets, {id: facet.id});

                                        currentBucket.values.forEach(function(value){
                                            for(var i=0;currentFacetData.items[i];i++){
                                                if(currentFacetData.items[i].value === value.value || currentFacetData.items[i].id === value.id){
                                                    filterValues.push(value.id);
                                                    break;
                                                }
                                            }
                                        });

                                        aggregationConfig.filter.fields[currentFacetData.id || currentFacetData.label] = {
                                            label: currentFacetData.id || currentFacetData.label,
                                            includeMissing: false,
                                            values: filterValues
                                        };
                                    }
                                });
                            }

                        }
                        return aggregationConfig;
                    }
                },
                defer: $scope.waitforfilter,
                pageSize: $scope.pageSize,
                label: $scope.waitforfilter? "Events" : "",
                openFilters: false
            };

            var $filtersWrapper, eventsChart;

            $scope.$watch('data', function(newValue, oldValue) {
                if (newValue && !_.isEqual(newValue, oldValue) && (!$scope.waitforfilter || $scope.filters)) {
                    getDataByDates();
                }
            });


            function setAggConfig(){
                var aggregationConfig = _.clone($scope.aggregationConfig);

                if(aggregationConfig.dataConfig) {
                    aggregationConfig.dataConfig.type = "count";
                    aggregationConfig.dataConfig.fromDate = $scope.dateRange.from.getTime();
                    aggregationConfig.dataConfig.toDate = $scope.dateRange.to.getTime();
                    aggregationConfig.dataConfig.interval = Math.max(Math.floor((aggregationConfig.dataConfig.toDate - aggregationConfig.dataConfig.fromDate) / 100), 60); // min interval size is 1 min - elastic search data provider expect to get inverval in milliseconds
                    aggregationConfig.dataConfig.dateField = "startTime";
                    aggregationConfig.index = 'events';

                    $scope.aggregationConfig = aggregationConfig;

                    if ($scope.tableConfig.fromDate !== aggregationConfig.dataConfig.fromDate) {
                        $scope.tableConfig.fromDate = aggregationConfig.dataConfig.fromDate;
                    }
                    if ($scope.tableConfig.toDate !== aggregationConfig.dataConfig.toDate) {
                        $scope.tableConfig.toDate = aggregationConfig.dataConfig.toDate;
                    }

                    DateRangeService.zoomTo(aggregationConfig.dataConfig.fromDate, aggregationConfig.dataConfig.toDate, aggregationConfig.dataConfig.interval);
                    return aggregationConfig;
                }

            }


            $scope.appsfields = [
                {"label": "Name", "path": "name", "template": "{{item.label || 'Unknown'}}", noSort:true},
                {"label": "#Of Targeted Hosts", "path": "count", "template": "{{(item.count) || 'Unknown'}}",noSort:true},
                {"label": "#Of Instances", "path": "docCount", "template": "{{item.docCount}}", noSort:true}
            ];

            $scope.domainsfields = [
                {"label": "Name", "path": "name", "template": "{{item.label || 'Unknown'}}", noSort:true},
                {"label": "#Of Instances", "path": "docCount", "template": "{{(item.docCount) || 'Unknown'}}", noSort:true}
            ];

            $scope.sitefields = [
                {"label": "Name", "path": "name", "template": "{{item.label || 'Unknown'}}", noSort:true},
                {"label": "#Of Targeted Hosts", "path": "count", "template": "{{item.count || 'Unknown'}}", noSort:true},
                {"label": "#Of Instances", "path": "docCount", "template": "{{(item.docCount) || 'Unknown'}}", noSort:true}
            ];


            function getDataByDates() {
                var aggregationConfig = setAggConfig();
                if(aggregationConfig){
                    $scope.auData = [];
                    store.fetch({
                        path: '/facets',
                        data: aggregationConfig,
                        dataObj: 'json',
                        method: 'POST',
                        filter: false,
                        queryParams: {'accountId': $state.params.accountId  || ""},
                        success: function(data) {
                            if(data && data.facets.length > 0){
                                var itemsData = data.facets[data.facets.length-1].items;
                                itemsData.forEach(function(item){
                                    var timeMS = GeneralUtilsService.getTimeInMiliseconds(parseInt(item.label));
                                    if (timeMS < aggregationConfig.dataConfig.fromDate ){
                                        timeMS = aggregationConfig.dataConfig.fromDate
                                    }
                                    else if (timeMS > aggregationConfig.dataConfig.toDate ){
                                        timeMS = aggregationConfig.dataConfig.toDate
                                    }
                                    item.date = new Date(timeMS);
                                    $scope.auData.push(item);
                                });
                                drawChart($scope.auData);

                            }
                            $scope.piechartdataversion = new Date().getTime();
                        }
                    });
                }
            }

            $scope.parseItems = function (dataItems, type) {
                var items = [];
//                if(dataItems){
//                    dataItems.forEach(function(dataItem){
//                        var tData = {};
//                        var name;
//
//                        tData.BytesSent = dataItem.counters.BytesSent;
//                        tData.BytesReceived = dataItem.counters.BytesReceived;
//                        tData.PacketsSent = dataItem.counters.PacketsSent;
//                        tData.PacketsReceived = dataItem.counters.PacketsReceived;
//                        tData.size = tData.BytesSent + tData.BytesReceived;
//
//                        if (type === "app") {
//                            tData.id = dataItem.application.id;
//                            tData.name = dataItem.application.display_name;
//                            tData.class = dataItem.application.category;
//                        }
//                        else if (type === "domain" || type === "detaildomain") {
//                            if(dataItem.tlDomain){
//
//                            }
//                            tData.id = dataItem.id;
//                            tData.appname = dataItem.appname;
//                            tData.tlDomain = dataItem.tlDomain;
//                            tData.domain = dataItem.domain;
//                            tData.dns = dataItem.dns;
//                            tData.httphost = dataItem.httphost;
//                            tData.serverport = dataItem.serverport;
//                            tData.categoryName = dataItem.categoryName ? dataItem.categoryName.join(', ') : "";
//                            name = (type === "domain") ? (dataItem.tlDomain || dataItem.domain) : dataItem.domain;
//                            tData.name = (dataItem.id !== "Others") ? name : "Others";
//                            tData.lastTimestamp = dataItem.lastTimestamp;
//                        }
//                        else if (type === "domainClassification" || type === "domainTlClassification") {
//                            tData.id = dataItem.id;
//                            tData.categoryName = dataItem.categoryName ? dataItem.categoryName.join(', ') : "";
//                            tData.domain = dataItem.domain;
//                            tData.providerName = dataItem.providerName;
//                            tData.updatedProvider = dataItem.updatedProvider;
//                            tData.updatedCategoryName = dataItem.updatedCategoryName;
//                            tData.classificationTimestamp = dataItem.classificationTimestamp;
//                            name = dataItem.domain + ";" + dataItem.category;
//                            tData.name = (dataItem.id !== "Others") ? name : "Others";
//                            tData.lastTimestamp = dataItem.lastTimestamp;
//                        }
//                        else if(type === "catoEntities"){
//                            tData.name = dataItem.name;
//                            tData.id = dataItem.pid;
//                            if(tData.name === "Others"){
//                                tData.hide = true;
//                                tData.id = "Others";
//                            }
//                            tData.type = dataItem.type;
//                            tData.pid = dataItem.pid;
//
//                        }
//                        else if(type === "clientIp"){
//                            tData.name = (dataItem.hostname && dataItem.hostname !== "")? dataItem.hostname : dataItem.id;
//                            tData.id = dataItem.id;
//                            tData.isHostName = (dataItem.hostname && dataItem.hostname !== "") && !dataItem.isStaticHost;
//                        }
//                        else {
//                            tData.name = dataItem.id;
//                            tData.id = dataItem.id;
//                        }
//
//                        tData.percent = (tData.size / $scope.dataCounters.bytesTotal * 100);
//                        if(tData.id === "Others"){
//                            tData.hide = true;
//                        }
//                        items.push(tData);
//                    });
//                }
                return dataItems;
            };

            function drawChart(data) {
                $('#events-chart-div').css('visibility', 'visible');
                if(eventsChart){
                    eventsChart.dataProvider = data;
                    eventsChart.validateData();
                }
                else {
                    eventsChart = AmCharts.makeChart("events-chart-div", {
                        "type": "serial",
                        fontFamily: 'Roboto',
                        addClassNames: true,
                        "path": "/public/javascripts/external/amcharts/",
                        "theme": "new",
                        "pathToImages": "/public/javascripts/external/amcharts/images/",
                        "categoryField": "date",
                        // "startDuration": 1,
                        "categoryAxis":{
                            gridAlpha: 0.15,
                            twoLineMode: true,
                            "minPeriod": '600ss',
                            "parseDates": true,
                            dateFormats: [{period:'fff',format:'JJ:NN:SS'},{period:'ss',format:'JJ:NN:SS'},{period:'mm',format:'JJ:NN'},{period:'hh',format:'JJ:NN'},{period:'DD',format:'MMM DD'},{period:'WW',format:'MMM DD'},{period:'MM',format:'MMM'},{period:'YYYY',format:'YYYY'}]
                        },
                        "chartCursor": {
                            cursorPosition: "mouse",
                            selectWithoutZooming: true,
                            "categoryBalloonDateFormat": "JJ:MM, MMM DD, YYYY"
                        },
                        "chartScrollbar": {
                            enabled: false
                        },
                        "trendLines": [],
                        "graphs": [
                            {
                                "fillAlphas": 1,
                                "id": "AmGraph-1",
                                "title": "graph 1",
                                "type": "column",
                                "dateFormat": "JJ, MMM DD, YYYY",
                                "fixedColumnWidth": 10,
                                "valueField": "count",
                                "lineColor":"#4395ce"
                            }
                        ],
                        "valueAxes": [
                            {
                                "id": "ValueAxis-1"
                            }
                        ],
                        "allLabels": [],
                        "balloon": {},
                        "dataProvider": data,
                        listeners: [
                            {
                                event: "init",
                                method: afterInit
                            }]

                    });
                }
            }

            function afterInit(chart){
                chart = chart.chart;
                chart.chartCursor.addListener("selected", handleZoom);

                chart.addListener("clickGraphItem", function (event) {
                    $scope.dateRange.from = new Date(event.item.category.getTime() - ($scope.aggregationConfig.dataConfig.interval));
                    $scope.dateRange.to = new Date(event.item.category.getTime() + ($scope.aggregationConfig.dataConfig.interval));
                });
                chart.chartCursor.addListener("onShowCursor", function (event) {
                    event.chart.chartDiv.style.cursor = "zoom-in";
                });
                chart.chartCursor.addListener("onHideCursor", function (event) {
                    event.chart.chartDiv.style.cursor = "default";
                });

            }


            function handleZoom(event) {
                var start = Math.min(event.start,event.end);
                var end = Math.max(event.start,event.end);

                $scope.dateRange.from = new Date(start);
                $scope.dateRange.to = new Date(end);
                $scope.options = {localFrom: start, localTo:end};
                event.chart.div.style.visibility = 'hidden';
                $scope.piechartdataversion = new Date().getTime();
                event.chart.chartCursor.clearSelection();
                return false;
            }

            var ready = false;
            var $eventsCharDiv, $clearZoom, readyTimeout;
            angular.element(document).ready(function(){
                ready = true;
                $filtersWrapper = $($element[0]).find('.filters-wrapper');
                $eventsCharDiv = $('#events-chart-div');
                $clearZoom =  $('.events-buttons');
            });

            function setChartMargin(){
                if(!$filtersWrapper || $filtersWrapper.length == 0) {
                    $filtersWrapper = $($element[0]).find('.filters-wrapper');
                }

                if(!ready || $filtersWrapper.length == 0) {
                    readyTimeout = $timeout(function(){
                        setChartMargin();
                    }, 50);
                    return;
                }

                var filtersHeight = $filtersWrapper.outerHeight();
                var auditChartHeight = $eventsCharDiv.height();

                $eventsCharDiv.css('marginTop', 5);
//                $filtersWrapper.css('marginTop', -(auditChartHeight + filtersHeight + 0));

                $clearZoom.css('marginTop', (auditChartHeight + filtersHeight - ($scope.pageMargin? 170 : ($filtersWrapper.find('.filters').hasClass('open')? 0 : 415))));
            }


        }]
    }
});